import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { PrescriptionService } from 'src/core/services/prescription.service';
import { DosageType } from 'src/interfaces/dosage-type';
import { Medicine } from 'src/interfaces/medicine';
import { UntypedFormBuilder, Validators,UntypedFormControl } from "@angular/forms";
import { Observable } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { LoaderService } from 'src/core/services/loader.service';
import { Router } from '@angular/router';
import { MatSelectChange } from '@angular/material/select';
import { MedicineDosagePackageType } from 'src/interfaces/medicine-dosage-package-type';
import { FocusedInput, FulfilmentItem } from 'src/interfaces/order-item';
import { StocktakeService } from 'src/core/services/stocktake.service';
import { UtilsService } from 'src/core/services/utils.service';

@Component({
    selector: 'app-stocktake-view',
    templateUrl: './stocktake-view.component.html',
    styleUrls: ['./stocktake-view.component.scss'],
    standalone: false
})
export class StocktakeViewComponent implements OnInit {

  @Input() items: FulfilmentItem[] = [];
  @ViewChild('barcodeInput') barcodeInput:ElementRef;
  
  medicinePage: number = 1;
  medicineLimit: number = 500;
  medicine: Medicine[] = [];
  dosageTypes: DosageType[] = [];
  selectedMedicine: Medicine | null = null;
  medicineDosageTypePackageTypes: MedicineDosagePackageType[] = [];
  FocusedInput = FocusedInput;
  activeItem: FulfilmentItem | null = null;
  barcodeDisabled: boolean = true;
  barcodeInputValid: boolean = false;
  scanCount: number = 0;
  medicineVisable: boolean = true;
  barcodeVisable: boolean = false;
  doneScanVisable: boolean = false;
  additionalInfoVisable: boolean = false;
  dosageTypeName: string | undefined= "";
  packageTypeName: MedicineDosagePackageType| undefined ;
  
  stocktakeForm = this.formBuilder.group({
    medicine: ['', Validators.required],
    quantity: ['', Validators.compose([Validators.required, Validators.min(1), Validators.max(500)])],
    batchNumber: ['', Validators.compose([
      Validators.required,
      Validators.pattern(
        "^([A-Z]{3,10}[0-9]{3,10})$"
      )
    ])],
    barcodeInput: this.formBuilder
        .control('',
          Validators.compose([
            Validators.required,
            Validators.pattern(
              /^([A-Z]{3,10}[0-9]{3,10}-[0-9]{3,10})$/
            )
          ])
        ),
    barcodeInputId: `barcodeInput`, 
    statusId: ['', Validators.required],
    dosageTypeId: ['', Validators.required],
    packageTypeId: ['', Validators.required],
    additional_information: [''],
    expiryDate: ['', Validators.required]
  });
 barcodeValidate = new UntypedFormControl('', [Validators.required,Validators.pattern(
  /^([A-Z]{3,10}[0-9]{3,10}-[0-9]{3,10})$/
)]);
  barcodeForm =  this.formBuilder.group({   
    barcodeInput: this.formBuilder
        .control('',
          Validators.compose([
            Validators.required,
            Validators.pattern(
              /^([A-Z]{3,10}[0-9]{3,10}-[0-9]{3,10})$/
            )
          ])
        ),
    barcodeInputId: `barcodeInput`, 
  });

  additionalInfoForm =  this.formBuilder.group({   
      additional_information: [''], 
  });


  filteredMedicine: Observable<Medicine[]>;
  isLoading: boolean = false;

  constructor(
    private prescriptionService: PrescriptionService,
    private formBuilder: UntypedFormBuilder,
    private loaderService: LoaderService,
    private _router: Router,
    private _stocktakeService: StocktakeService,
    private _utilsService: UtilsService,
  ) {
  }

  ngOnInit(): void {

    this
      .loaderService
      .isLoading
      .subscribe(isLoading => {
        this.isLoading = isLoading;
      });

    this
      .stocktakeForm
      .controls['medicine']
      .valueChanges
      .subscribe(value => {
        this.getMedicine(value);
      });

  }

  async getMedicine(value: string) {
    this.medicine = await this
      .prescriptionService
      .getMedicine(value, this.medicinePage, this.medicineLimit);
  }

  medicineSelected(event: MatAutocompleteSelectedEvent) {
    this.selectedMedicine = event.option.value;

    if (!this.selectedMedicine) return;

    this
      .stocktakeForm
      .patchValue({
        medicine: this.selectedMedicine.name,
      });

    this.getMedicineDosageTypes(this.selectedMedicine.id);
  }


  getMedicineDosageTypes(medicineId: number) {

    this
      .prescriptionService
      .getMedicineDosageTypes(medicineId)
      .subscribe(dosageTypes => {
        this.dosageTypes = dosageTypes;
      });

  }

  getMedicineDosagePackageTypes(event: MatSelectChange) {
    const dosageTypeId = parseInt(event.value);
    if (!this.selectedMedicine) return;

    this
      .prescriptionService
      .getMedicineDosagePackageTypes(this.selectedMedicine.id, dosageTypeId)
      .subscribe(medicineDosagePackageTypes => {
        this.medicineDosageTypePackageTypes = medicineDosagePackageTypes;
      })
  }

  activateItem(item: FulfilmentItem) {
    // check if there was an active item
    if(item.activated) return;

    const previvousActiveItem: FulfilmentItem | undefined = this.items
      .find(item => {

        if (!this.activeItem) return false;
        return item.orderItem.id == this.activeItem.orderItem.id;
      });


    if (previvousActiveItem) {
      previvousActiveItem.activated = false;
      previvousActiveItem.focusedInput = FocusedInput.None;
      previvousActiveItem.barcodeInput.reset();
      previvousActiveItem.medicineNumberInput.reset();
    }

    this.activeItem = item;

    item.activated = true;
    // Only execute this if item was not activated by 
    
  } 

  async setItem(){
    this.dosageTypeName = this.dosageTypes.find(x => x.id == this.stocktakeForm.value.dosageTypeId)?.additional_information;
    this.packageTypeName = this.medicineDosageTypePackageTypes.find(x => x.id == this.stocktakeForm.value.packageTypeId);
    if(this.stocktakeForm.value.medicine !== '' && this.stocktakeForm.value.packageTypeId !== ""){
      this.medicineVisable = false;
      this.barcodeVisable = true;
      this.doneScanVisable = true;
      this.barcodeDisabled = false;
      const payload = {
        medicine_dosage_package_type_id: this.stocktakeForm.value.packageTypeId,
      }
      const resp = await this._stocktakeService.getCount(payload);
      this.scanCount = resp;
      this.barcodeInput.nativeElement.focus();
    }else{
      
      this._utilsService
      .showError({error:{message:'Please select medicine to continue.'}});
    }
 
  }
  async checkBarcode(){
    // Prefer the form control value (kept in sync by matInput + formControl)
    const barcode = (this.barcodeValidate.value ?? '').toString().trim();
    this.barcodeInputValid = /^([A-Z]{3,10}[0-9]{3,10}-[0-9]{3,10})$/.test(barcode);

    // Reject empty / invalid scans (Enter with no usable barcode)
    if (!this.barcodeInputValid) {
      this.barcodeValidate.markAsTouched();
      return;
    }

    const payload = {
      barcode: barcode,
      medicine_dosage_package_type_id: this.stocktakeForm.value.packageTypeId,
    }
    await this._stocktakeService.addBarcode(payload);
    await this.setItem();
    this.barcodeValidate.reset('');
    this.barcodeInput.nativeElement.focus();
  }
  async checkData() {
    this.barcodeInputValid = true;
    const payload = {
      medicine_dosage_package_type_id: this.stocktakeForm.value.packageTypeId,
    }
    const resp = await this._stocktakeService.checkStocktake(payload);
    this.doneScanVisable = false;
    if(!resp){
      this.additionalInfoVisable = true;
    }else{
      this.submitData();
    }
  }

  async submitData() {
    
    const payload = {
      medicine: this.stocktakeForm.value.medicine,
      dosage_type_id: this.stocktakeForm.value.dosageTypeId,
      medicine_dosage_package_type_id: this.stocktakeForm.value.packageTypeId,
      additional_information: this.additionalInfoForm.value.additional_information
    }
    const resp = await this._stocktakeService.updateStocktake(payload);
    
    // Realod page
    this._router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => {
          this._router.navigate(['/portal/stocktake']);
        })
  }

}

